import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-invalid-url',
    templateUrl: './invalid-url.component.html',
    styleUrls: ['./invalid-url.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InvalidUrlComponent {

}
